import { NgModule } from '@angular/core';
import { PreventRedirectHandlerDirective } from './prevent-redirect-handler.directive';

@NgModule({
  declarations: [PreventRedirectHandlerDirective],
  exports: [PreventRedirectHandlerDirective],
})
export class PreventRedirectHandlerModule {}
